module.exports = __webpack_public_path__ + "static/media/typingdark.2aeb7936.mp4";